<template>
    <div class="login-view">
        <div class="card">
			<div class="card-body">
				<div class="m-sm-4">
                    <p class="lead text-center">
                        野灣野生動物救援HIS管理系統
                    </p>
                    <div class="text-center">
                        <img src="@/assets/img/wildoneHis/kingfisher.png" alt="Linda Miller" class="img-fluid rounded-circle" width="132" height="132">
                    </div>
					<form class="text-start">
                        <div class="form-group">
                            <label>帳號</label>
                            <input 
                                class="form-control form-control-lg" 
                                ref="emailInput"
                                type="email" 
                                name="email" 
                                :class="{'error':inputForm.email.error}"
                                :placeholder="inputForm.email.placeholder"
                                v-model="inputForm.email.value"
                                @keyup.enter="()=>{
                                    this.$refs.passwordInput.focus()
                                }"
                            >
                        </div>
                        <div class="form-group">
                            <label>密碼</label>
                            <input 
                                class="form-control form-control-lg" 
                                type="password" 
                                name="password" 
                                ref="passwordInput"
                                :class="{'error':inputForm.password.error}"
                                :placeholder="inputForm.password.placeholder"
                                v-model="inputForm.password.value"
                                @keyup.enter="()=>{
                                    this.loginHandle()
                                }"
                            >
                        </div>
                        <!-- <div>
                            <div class="custom-control custom-checkbox align-items-center">
                                <input id="customControlInline" type="checkbox" class="custom-control-input me-2" value="remember-me" name="remember-me" checked="">
                                <label class="custom-control-label text-small" for="customControlInline">記住我</label>
                            </div>
                        </div> -->
                        <div class="text-center mt-3">
                            <button type="button"
                                class="btn btn-lg btn-primary"
                                @click="loginHandle"
                            >登入</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LoginView',
    data(){
        return {
            inputForm:{
                email:{
                    value:'',
                    error:false,
                    placeholder:'請輸入email帳號'
                },
                password:{
                    value:'',
                    error:false,
                    placeholder:'請輸入密碼'
                }
            },
            
        }
    },
    components: {
      
    },
    methods:{
        checkInput(){
            if ( this.inputForm.email.value.trim() === '' ){
                this.inputForm.email.error = true
                this.inputForm.email.placeholder = '請輸入email帳號'
                return false
            }
            //檢查帳號輸入格式
            if ( !this.$api.users.isValidEmail(this.inputForm.email.value.trim()) ){
                this.inputForm.email.error = true
                this.inputForm.email.placeholder = '請輸入email格式'
                this.inputForm.email.value = ''
                this.$store.state.actionResult.show({status:'fail',massage: this.inputForm.email.placeholder})
                return false
            }
            if ( this.inputForm.password.value.trim() === '' ){
                this.inputForm.password.error = true
                this.inputForm.password.placeholder = '請輸入密碼'
                this.$store.state.actionResult.show({status:'fail',massage: this.inputForm.password.placeholder})
                return false
            }
            
            
            return true
        },
        async loginHandle(){

            if ( !this.checkInput() ){
                return
            }

            this.$store.state.loadingStatus = true
            let objFrom = new FormData()
            objFrom.append('email', this.inputForm.email.value.trim() )
            const password = this.$api.AES_ECB_ENCRYPT(this.inputForm.password.value.trim())
            objFrom.append('password', password )
            const res = await this.$api.users.login(objFrom);
            this.$store.state.loadingStatus = false
            if ( res.code !== 200 ){
                this.$store.state.actionResult.show({status:'fail',massage:res.msg})
                switch (res.code) {
                    case -1:
                        this.inputForm.email.error = true
                        this.inputForm.email.placeholder = '帳號不存在'
                        break;
                    case -1:
                        this.inputForm.password.error = true
                        this.inputForm.password.placeholder = '密碼錯誤'
                        break;
                    case -2:
                        this.inputForm.email.error = true
                        this.inputForm.email.placeholder = '帳號停用，請洽管理員'
                        break;
                    default:
                        break;
                }
                return
            }
            this.$store.state.actionResult.show({status:'success',massage:'登入成功'})
            this.$api.users.loginSuccessHandle(res.data.token,res.data.per)
            this.$router.push('/dashboard/index')
            
        }
    },
    created(){
        if ( localStorage.getItem('wildone_account') ){
            localStorage.removeItem('wildone_account')
        }
        if ( localStorage.getItem('wildone_per') ){
            localStorage.removeItem('wildone_per')
        }
        this.$api.users.userData = null
        this.$api.users.userPermission = null
    }
}
</script>
<style scoped>
.login-view{
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative; /* 使 ::before 绝对定位相对于这个容器 */
    background-image: url('@/assets/img/wildoneHis/clouded leopard LOGO.png');
    background-repeat: no-repeat;
    background-size: 20rem;
    background-position-x: 6rem;
    background-position-y: 5rem;

}
.login-view::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.4); /* 白色半透明，調整 alpha 值以改變壓淡程度 */
    z-index: 1; /* 讓遮罩在背景圖片上 */
}

.content {
    position: relative; /* 使内容在遮罩之上 */
    z-index: 2;
}
.login-view > .card {
    min-width: 406px;
    max-width: 576px;
    height: fit-content;
    z-index:2;
}
.img-fluid{
    background-color: #f4f7fc;
}
@media (max-width: 767px) {
    .login-view > .card {
        min-width: 406px;
        width: 90% !important;
    }
}

</style>
  